const editButtons = document.querySelectorAll('.js-edit-resource-link-trigger')

function initResourceLinks(editButton) {
  const container = document.querySelector(".js-c-resources_links-list")
  if (!container) return

  const groupId = container.dataset.groupId
  const caseId = container.dataset.caseId
  if (!groupId || !caseId) return

  const form = document.getElementById("edit-resource-link-form")
  if (!form) return

  const nameInput = form.querySelector("#rms_resource_link_name")
  const linkInput = form.querySelector("#rms_resource_link_link")
  if (!nameInput || !linkInput) return

  editButton.addEventListener("click", () => {
    const linkId = editButton.dataset.resourceLinkId
    const name = editButton.dataset.resourceLinkName
    const link = editButton.dataset.resourceLinkLink
    const editUrl = editButton.dataset.resourceLinkEditUrl

    if (!linkId || !name || !link, !editUrl) return window.alert("Oh bork, something went wrong when you were trying to add a link. Please try again later.")

    form.action = editUrl
    nameInput.value = name
    linkInput.value = link
  })
}

editButtons.forEach(initResourceLinks)
